/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var MetadataStoreServiceName = "MetadataStoreService";
export var CachedMetadataStoreServiceName = "CachedMetadataStoreService";
